import { getImageUrl } from '@helpers/image';
import { Device } from '@helpers/media';
import Breadcrumb from '@stories/Components/Breadcrumb/Breadcrumb';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import { Column, Grid, GridColumns } from '@stories/Components/Global/Grid/Grid';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import Heading from '@stories/Components/Global/Typography/Heading';
import Paragraph from '@stories/Components/Global/Typography/Paragraph';
import React, { useLayoutEffect, useState } from 'react';
import { BrandPageBannerStyles as s } from './BrandPageBanner.styles';
const BrandPageBanner = ({ breadcrumb, superTitle, title, content, imageUrl, imageAltText, cta, }) => {
    const [activeBanner, setActiveBanner] = useState(false);
    useLayoutEffect(() => {
        const isInView = (elem) => {
            const box = elem.getBoundingClientRect();
            return box.top < window.innerHeight && box.bottom >= 0;
        };
        const onScroll = () => {
            let formVisible = false;
            const elemTarget = document.getElementById('enquire-form');
            if (elemTarget) {
                formVisible = isInView(elemTarget);
            }
            if (window.scrollY > 0 && elemTarget && !formVisible) {
                setActiveBanner(true);
            }
            else {
                setActiveBanner(false);
            }
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    return (React.createElement(s.Wrapper, { active: activeBanner },
        breadcrumb && (React.createElement(s.BreadcrumbWrapper, null,
            React.createElement(SiteWide, null,
                React.createElement(Breadcrumb, { ...breadcrumb })))),
        React.createElement(SiteWide, null,
            React.createElement(Grid, { split: GridColumns.Half, collapseAtViewport: Device.Tablet },
                React.createElement(Column, null,
                    React.createElement(s.ContentWrapper, null,
                        React.createElement(s.SubWrapper, null,
                            superTitle && (React.createElement(s.SuperTitleContainer, null,
                                React.createElement(Paragraph, { size: "regular" }, superTitle))),
                            React.createElement(s.TitleContainer, null,
                                React.createElement(Heading, { visual: 'h4', semantic: 'h1' }, title))),
                        superTitle && (React.createElement(s.ImageContainerMobile, null,
                            React.createElement(s.ImageContainer, null,
                                React.createElement(s.Image, { alt: imageAltText, role: imageAltText ? undefined : 'presentation', loading: "lazy", src: getImageUrl(imageUrl, { mode: 'pad', width: 640, heightratio: 194 / 345 }), srcSet: [
                                        `${getImageUrl(imageUrl, { mode: 'pad', width: 640, heightratio: 194 / 345 })} 1x`,
                                        `${getImageUrl(imageUrl, { mode: 'pad', width: 1280, heightratio: 194 / 345 })} 2x`,
                                    ].join(',') })))),
                        content && (React.createElement(s.ContentContainer, null,
                            React.createElement(Paragraph, { size: "regular" },
                                React.createElement(s.Content, { dangerouslySetInnerHTML: { __html: content } })))),
                        cta && (React.createElement(s.ButtonContainer, null,
                            React.createElement(LinkButton, { title: cta.text, branding: 'primary', target: cta.target, href: cta.url }))))),
                React.createElement(Column, null,
                    React.createElement(s.ImageContainerDesktop, { active: superTitle ? true : false },
                        React.createElement(s.ImageContainer, null,
                            React.createElement(s.Image, { alt: imageAltText, loading: "lazy", src: getImageUrl(imageUrl, { mode: 'pad', width: 640, heightratio: 311 / 553 }), srcSet: [
                                    `${getImageUrl(imageUrl, { mode: 'pad', width: 640, heightratio: 311 / 553 })} 1x`,
                                    `${getImageUrl(imageUrl, { mode: 'pad', width: 1280, heightratio: 311 / 553 })} 2x`,
                                ].join(',') }))))))));
};
export default BrandPageBanner;
